import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/chevron-down.svg';
export default {
  name: 'CollapsablePanel',
  props: {
    url: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      isFolded: true
    };
  }
};